module.exports = __webpack_public_path__ + "static/media/layout.eecaa903.svg";